const constantSuggestion: any = {
  study_competitor: {
    text: '😍 TA VOIE IDÉALE : CLASSE PRÉPA',
    subtitle: [
      'Si tu es une personne de style Compétiteur, je te recommande de faire une classe préparatoire aux grandes écoles (CPGE).',
    ],
    list: [
      "Après une filière générale débouchant sur des résultats brillants au baccalauréat (plus de 14 de moyenne), tu intégreras une classe préparatoire aux grandes écoles (CPGE), si possible parmi les mieux classées.",
      "Après deux ans (voire trois ans en cas d'échec aux concours), tu intégreras une grande école de commerce ou d’ingénieur, la première étape d'une carrière professionnelle prometteuse !",
    ],
    citation:
      "« Baisser les bras dans une compétition sous prétexte qu'on ne peut terminer premier est incompatible avec l'esprit du sport. »",
    author: 'Eric Tabarly',
    subtitle2: [],
  },
  study_epicurean: {
    text: '😍 TA VOIE IDÉALE : LE BACHELOR',
    subtitle: [
      "Après une filière générale ou technologique débouchant sur des résultats moyens au baccalauréat, tu intégreras une école privée post-Bac dans le cadre dun Bachelor.💪",
    ],
    list: [
      "Après cette première séquence de formation, tu pourras poursuivre tes études en Master au sein de la même école où tu auras su te faire une place au soleil et cultiver tes réseaux.",
      "Tes études seront sous le signe des expériences et des découvertes : voyages, stages à l'étranger, junior entreprise et bien sûr, faire la fête 🥳 !!!",
    ],
    citation: '« Le plaisir est le commencement et la fin de la vie heureuse. »',
    author: 'Épicure',
    subtitle2: [],
  },
  study_freethinker: {
    text: '😍 TA VOIE IDÉALE : INSTITUT D’ÉTUDES POLITIQUES (I.E.P)',
    subtitle: [],
    list: [
      "Après une filière générale débouchant sur de bons résultats au baccalauréat, tu intégreras un Institut d’Etudes Politiques (IEP) où tu prépareras une licence en sciences politiques.",
    ],
    subtitle2: [
      'Ces trois années d’études te permettront de te doter d’outils intellectuels pour penser et analyser la société dans laquelle tu vis.',
      'Les échanges avec les autres élèves, partageant les mêmes centres d’intérêts, te procureront une grande satisfaction intellectuelle, ainsi que les échanges avec tes professeur(e)s, des personnalités aux parcours personnels et professionnels riches.',
    ],
    citation:
      '« Qu’est-ce qu’un penseur ? Un homme qui se pose encore des questions quand les autres ne s’en posent plus. »',
    author: 'André Frossard',
  },
  study_theorist: {
    text: '😍 TA VOIE IDÉALE : LICENCE UNIVERSITAIRE',
    subtitle: [
      'L’Université est ton environnement idéal car on y étudie une seule matière de façon spécialisée.',
      "De plus le contexte t'offrira une grande autonomie dans ton travail et dans ton organisation ce qui correspond au mieux à ta personnalité.",
    ],
    list: [
      "L’Université est le lieu de formation des expert(e)s. Les enseignements sont théoriques et portent plutôt sur des concepts que sur des applications pratiques. Tu apprécieras ce type d’enseignements complexes qui te permettront d’acquérir des clefs pour comprendre le monde.",
    ],
    citation:
      "« La théorie, c'est quand on sait tout et que rien ne fonctionne. La pratique, c'est quand tout fonctionne et que personne ne sait pourquoi. Ici, nous avons réuni théorie et pratique : Rien ne fonctionne... et personne ne sait pourquoi ! »",
    author: 'Albert Einstein',
    subtitle2: [],
  },
  study_realistic: {
    text: '😍 TA VOIE IDÉALE : BTS',
    subtitle: [],
    list: [
      "Après une filière technologique ou professionnelle débouchant sur un baccalauréat, tu intégreras un BTS, éventuellement en alternance.",
      'Après deux années, voire trois années, si tu désires compléter ton BAC+2 par une licence professionnelle (en IUT ou dans une Université), tu rentreras sur le marché du travail.',
    ],
    subtitle2: [
      "Ce premier emploi te permettra de prendre ton indépendance vis-à-vis de tes parents et de construire ta vie. Ta carrière dépendra ensuite des opportunités que ton employeur t'offrira et de tes ambitions. C'est au travail, que tu découvriras tes véritables talents et ton véritable potentiel.",
    ],
    citation:
      "« Le pessimiste se plaint du vent, l'optimiste espère qu'il va changer, le réaliste ajuste ses voiles. »",
    author: 'William Arthur Ward',
  },
  study_enterprising: {
    text: '😍 TA VOIE IDÉALE : BUT',
    subtitle: [
      'Après une terminale générale ou technologique, tu intégreras un BUT.',
    ],
    list: [
      "Le BUT est l’environnement idéal pour toi car on y étudie différentes matières (droit, sciences, marketing, communication, etc.).",
    ],
    citation:
      '« L’échec est seulement l’opportunité de recommencer d’une façon plus intelligente. »',
    author: 'Henry Ford',
    subtitle2: [
      "Les enseignements sont théoriques et de très bon niveau puisque dispensés par des professeur(e)s d’Université, mais aussi pratiques avec de très nombreux projets individuels ou collectifs à réaliser, complétés par des stages en entreprise et l’intervention de professionnel(le)s. Le BUT est fait pour les hommes et les femmes d'action qui ont de l'ambition !"
    ],
  },
} as const;

export default constantSuggestion;


